import { GET_LANE_RATE_LIST } from './actions';

import { REQUEST, SUCCESS } from '../../../utils/actionGenerator';

const defaultState = {
  laneRateList: {
    results: [],
    totalCount: 0,
  },
  page: 1,
  page_size: 50,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_LANE_RATE_LIST[REQUEST]:
      return { ...state ,page : action.params.page};
    case GET_LANE_RATE_LIST[SUCCESS]:
      return {
        ...state,
        laneRateList: {
          ...state.laneRateList,
          results: [...state.laneRateList.results, ...action.response.results], 
          totalCount: action.response.totalCount || state.laneRateList.totalCount,
        },
        page: action.response.page + 1
      };
    default:
      return state;
  }
}

export const getLaneRateList = (state) => state.laneRateDashboard.laneRateList;
